import { QueryClient } from '@tanstack/react-query';

const queryClient = new QueryClient();
queryClient.setDefaultOptions({
  queries: { refetchOnWindowFocus: false, refetchOnMount: true, retry: 0 },
});

export default queryClient;
